import httpClient from "../xhr";
const controller = new AbortController();

async function post(url, payload, options = {}) {
  try {
    const OPTION_WRAPPER = { ...options, signal: controller.signal };
    const res = await httpClient.post(`${url}`, payload, OPTION_WRAPPER);
    return await res.data;
  } catch (error) {
    throw error;
  }
}
async function get(url, options = {}) {
  try {
    const OPTION_WRAPPER = { ...options, signal: controller.signal };
    const res = await httpClient.get(`${url}`, OPTION_WRAPPER);
    return await res.data;
  } catch (error) {
    throw error;
  }
}
async function deleterequest(url, payload, options = {}) {
  try {
    const OPTION_WRAPPER = { ...options, signal: controller.signal };
    const res = await httpClient.delete(
      `${url}`,
      { data: payload },
      OPTION_WRAPPER
    );
    return await res.data;
  } catch (error) {
    throw error;
  }
}

async function put(url, payload, options = {}) {
  try {
    const OPTION_WRAPPER = { ...options, signal: controller.signal };
    const res = await httpClient.put(`${url}`, payload, OPTION_WRAPPER);
    return await res.data;
  } catch (error) {
    throw error;
  }
}

async function patch(url, payload, options = {}) {
  try {
    const OPTION_WRAPPER = { ...options, signal: controller.signal };
    const res = await httpClient.patch(`${url}`, payload, OPTION_WRAPPER);
    return await res.data;
  } catch (error) {
    throw error;
  }
}
export const MasterService = {
  post,
  get,
  put,
  deleterequest,
  patch
};
